import $ from "jquery";
import FileInfoUtil from "../util/FileInfoUtil";
import ThumbnailUtil from "../util/ThumbnailUtil";
import DownloadPreviewRequest from "../helper/DownloadPreviewRequest";
import PreviewConstraints from "../helper/PreviewConstraints";
import PreviewRequestEntry from "../helper/PreviewRequestEntry";
import _ from "lodash";
import MultiFormatDownloadsRespPreview from "./MultiFormatDownloadsRespPreview";
import SimpleArgsClassPreview from "./SimpleArgsClassPreview";
import ErrorId from "../protocol/ErrorId";
import FetchJsonJob from "../protocol/FetchJsonJob";
import t from '../i18n/I18n';

export default class PreviewHelper {
  constructor(repoItem, items, fuid2ArgsHelperMap, resolution, jobId, pageNumber, videoFrameRate) {
    this.repoItem = repoItem;
    this.items = items;
    this.fuid2ArgsHelperMap = fuid2ArgsHelperMap;
    this.resolution = resolution;
    this.jobId = jobId;
    this.pageNumber = pageNumber;
    this.videoFramerate = videoFrameRate;
  }

  /* getPreviewUrl(size = 0) {
    if (FileInfoUtil.isAudioOrVideo(this.repoItem)) {
      return ThumbnailUtil.createVideoPreviewUrl(this.repoItem, size);
    } else if (FileInfoUtil.isImage(this.repoItem) || FileInfoUtil.isMultiPage(this.repoItem)) {
      return ThumbnailUtil.createImagePreviewInfoUrl(this.repoItem);
    }
    return '';
  } */

  getInfoUrl() {
    if (FileInfoUtil.isAudioOrVideo(this.repoItem)) {
      return ThumbnailUtil.createVideoPreviewInfoUrl(this.repoItem);
    } else {
      return ThumbnailUtil.createImagePreviewInfoUrl(this.repoItem);
    }
  }

  getJobProgressStatusUrl() {
    return ThumbnailUtil.createJobProgressInfoUrl(this.jobId);
  }

  parseAndLoadInfoResult(jsonData) {
    /**
     * @type {number}
     * @private
     */
    this._width = jsonData['width'] ? jsonData['width'] : 0;
    /**
     * @type {number}
     * @private
     */
    this._height = jsonData['height'] ? jsonData['height'] : 0;
    /**
     * @type {number}
     * @private
     */
    this._duration = jsonData['duration'] ? jsonData['duration'] : 0;
    /**
     * @type {number}
     * @private
     */
    this._defaultSize = jsonData['defaultSize'] ? jsonData['defaultSize'] : 0;
    /**
     * @type {Array.<number>}
     * @private
     */
    this._availableSizes = jsonData['availableSizes'] ? jsonData['availableSizes'] : [];

    /**
     * @type {number}
     * @private
     */
    this._totalPages = jsonData['totalPages'] ? jsonData['totalPages'] : 0;
    /**
     * @type {number}
     * @private
     */
    this._videoFrameRate = jsonData['videoFrameRate'] ? jsonData['videoFrameRate'] : 0;

    const {subtitles = [], audioTracks = []} = jsonData.subtitlesAndTracks || {};
    /**
     * @type {Array.<object>}
     * @private
     */
    this._subtitles = subtitles;

    /**
     * @type {Array.<object>}
     * @private
     */
    this._audioTracks = audioTracks;

    this._type = jsonData['mediaType'] ? jsonData['mediaType'] : undefined;
  }

  get totalPages() {
    return this._totalPages;
  }

  get width() {
    return this._width;
  }

  get height() {
    return this._height;
  }

  /**
   * Duration is in Milliseconds.
   * Note: This is not application to images.
   * @return {number}
   */
  get duration() {
    return this._duration;
  }

  /**
   * Default size at which preview generation will happen, if size is not passed.
   * @return {number}
   */
  get defaultSize() {
    return this._defaultSize;
  }

  /**
   * Video Frame Rate
   * @return{number}
   *  */
  get videoFrameRate() {
    return this._videoFrameRate;
  }

  /**
   * Number array of sizes.
   * Display this array in video size selection...
   * Note: This is not application to images.
   * @return {Array.<number>}
   */
  get availableSizes() {
    return this._availableSizes;
  }

  get mediaType() {
    return this._mediaType;
  }

  getDownloadData() {
    const downloadPreviewRequest = new DownloadPreviewRequest();
    downloadPreviewRequest.previewRequestEntries = [];

    _.map(this.items, (item, index) => {
      const argHelper = !this.fuid2ArgsHelperMap ? null : this.fuid2ArgsHelperMap.get(item.getFuid());
      const __selectedFormat = !argHelper ? null : argHelper.selectedFormat;
      const isNative = !__selectedFormat;

      const _previewConstraints = new PreviewConstraints();
      _previewConstraints.pageNo = this.pageNumber;
      _previewConstraints.fileFormat = isNative
        ? argHelper.formatType == null
          ? 'NATIVE'
          : argHelper.formatType
        : argHelper.formatType;
      if (_previewConstraints.fileFormat == null) {
        _previewConstraints.fileFormat = 'NATIVE';
      }

      _previewConstraints.preDefinedFormat = isNative ? null : __selectedFormat.getName();

      _previewConstraints.resolution = this.resolution;

      if (argHelper) {
        _previewConstraints.cropX = argHelper.cropX;
        _previewConstraints.cropY = argHelper.cropY;
        _previewConstraints.cropHeight = argHelper.cropHeight;
        _previewConstraints.cropWidth = argHelper.cropWidth;
        _previewConstraints.addLabel = argHelper.addLabel;
        if (argHelper.svg) _previewConstraints.svg = argHelper.svg;
      }

      if (!isNative) {
        let argTokenDetailIdList = [];
        _.map(__selectedFormat.getArgTokenDetailsIdList(), (token, index) => {
          const simpleArgs = new SimpleArgsClassPreview();
          simpleArgs.name = token.getName();
          if (token.getName() === 'Resolution') {
            const valueMap = [];
            valueMap.push({key: 'X', value: argHelper.resolutionX.toString()});
            valueMap.push({key: 'Y', value: argHelper.resolutionY.toString()});
            simpleArgs.varNameToValue = valueMap;
          } else {
            const __tokens = token.getVarNameToValue();
            const _keyValueArray = [];
            _.map(__tokens, (value) => {
              const __key = value.getKey();
              if (__key === 'FirstPage' || __key === 'LastPage') {
                _keyValueArray.push({key: __key, value: this.pageNumber.toString()});
              } else if (__key === 'Width') {
                _keyValueArray.push({key: __key, value: argHelper.resolutionX.toString()});
              } else if (__key === 'Height') {
                _keyValueArray.push({key: __key, value: argHelper.resolutionY.toString()});
              } else _keyValueArray.push({key: __key, value: value.getValue()});
            });

            simpleArgs.varNameToValue = _keyValueArray;
          }

          argTokenDetailIdList.push(simpleArgs);
        });

        const multiFormatDownloadsResp = new MultiFormatDownloadsRespPreview(
          __selectedFormat.getName(),
          __selectedFormat.getId(),
          argTokenDetailIdList
        );
        multiFormatDownloadsResp.outputFormats = __selectedFormat.getOutputFormats();
        _previewConstraints.multiFormatDownloadsRespPreview = multiFormatDownloadsResp;
      }

      let _previewRequestEntry = new PreviewRequestEntry();
      _previewRequestEntry.bid = item.getBid();
      _previewRequestEntry.fuid = item.getFuid();
      _previewRequestEntry.frn = argHelper.getFrn() ? argHelper.getFrn() : item.getFrn();
      _previewRequestEntry.rrn = argHelper.getRrn() ? argHelper.getRrn() : item.getRrn();
      _previewRequestEntry.fqPath = item.getRemotePath();
      _previewRequestEntry.previewConstraints = _previewConstraints;

      downloadPreviewRequest.collectionId = window.ARGS.collectionId;
      downloadPreviewRequest.previewRequestEntries.push(_previewRequestEntry);
    });

    return JSON.stringify(downloadPreviewRequest);
  }

  loadJobId() {
    return new Promise((onSuccess, onFailure) => {
      const downloadUrl = ThumbnailUtil.createDownloadJobIdUrl();
      const formData = {
        data: this.getDownloadData()
      };
      //Fixed: WC-272 Improper use of jquery ajax on GET request - Om
      $.ajax({
        dataType: 'json',
        method: 'POST',
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        data: formData,
        url: downloadUrl
      })
        .done((data, textStatus, jqXHR) => {
          onSuccess(data);
        })
        .fail((jqXHR, textStatus, errorThrown) => {
          let response = jqXHR && jqXHR.responseText ? JSON.parse(jqXHR.responseText) : {
            success: false,
            message: errorThrown
          };
          if (!response.message) {
            response.message = t('OPERATION_FAILED', { PARAM: this.jobId });
          }
          onFailure(response);
          console.log('Fail for Job ID');
        })
        .always(() => {
        });
    });
  }

  issueJobProgressCall() {
    return new Promise((onSuccess, onFailure) => {
      const __progressUrl = this.getJobProgressStatusUrl();
      $.ajax({
        contentType: false, //Fixed: WC-272 Improper use of jquery ajax on GET request - Om
        dataType: 'json',
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        method: 'GET',
        url: __progressUrl
      })
        .done((data, textStatus, jqXHR) => {
          onSuccess(data);
        })
        .fail((jqXHR, textStatus, errorThrown) => {
          console.log('Failed to get the progress for jobId ' + this.jobId);
          let response = jqXHR && jqXHR.responseText ? JSON.parse(jqXHR.responseText) : {
            success: false,
            message: errorThrown
          };
          if (!response.message) {
            response.message = t('OPERATION_FAILED', { PARAM: this.jobId });
          }
          onFailure(response);
        })
        .always(() => {
        });
    });
  }

  loadInfo() {
    const url = this.getInfoUrl();
    const resolve = (data) => {
      this.parseAndLoadInfoResult(data);
      return this;
    };

    const reject = () => ErrorId.PREVIEW_INFO_LOAD_FAIL + url;
    const job = new FetchJsonJob(url, resolve, reject);
    return job;
  }

  static loadInfo(repoItem) {
    return new PreviewHelper(repoItem).loadInfo();
  }

  static loadJobId(items, fuid2ArgsHelperMap, resolution = -1, pageNumber = 0) {
    return new PreviewHelper(null, items, fuid2ArgsHelperMap, resolution, -1, pageNumber).loadJobId();
  }

  static checkJobProgress(jobId) {
    return new PreviewHelper(null, null, null, null, jobId).issueJobProgressCall();
  }
}
